(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["content-video"] && !Shopify.designMode) return;
  try {
    // Handle poster overlay click on mobile for iframes
  document.addEventListener('DOMContentLoaded', function() {
    const posterOverlays = document.querySelectorAll('.content-video__poster');
    
    posterOverlays.forEach(function(poster) {
      const playButton = poster.querySelector('.content-video__play-button');
      
      if (playButton) {
        playButton.addEventListener('click', function() {
          const videoContainer = poster.closest('.content-video');
          const iframe = videoContainer.querySelector('.content-video__iframe');
          
          if (iframe) {
            // Add autoplay parameter to iframe src
            const currentSrc = iframe.src;
            const separator = currentSrc.includes('?') ? '&' : '?';
            iframe.src = currentSrc + separator + 'autoplay=1';
            
            // Hide poster
            videoContainer.classList.add('content-video--playing');
          }
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
